module.exports = __webpack_public_path__ + "img/start.1c3c3304.png";